// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"a9490983","112":"dcb8da9f","538":"2e404abc","702":"69325fdd"}[chunkId] + ".chunk.css";
};